/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { BaseApi } from './BaseApi';

export class DisaggregationTypeApi extends BaseApi {
  endPoint: string = '/api/admin/disaggregation-types';
}
